// extracted by mini-css-extract-plugin
module.exports = {"error500":"Error500_error500__OTdZ0","error500__info":"Error500_error500__info__xDqib","error500__image":"Error500_error500__image__adcBj"};